import { FC } from 'react';
import { RouteRedirect } from 'modules/routing-module';

export const Desktop: FC = () => <RouteRedirect routeKey="DesktopManagement" />;
